module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter5"
    }
  }, [_c('h1', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _c('a', {
    attrs: {
      "href": "#/005toc#ch5"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_vm._v("HERBED CHICKEN COCKTAIL BITES")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Meatballs are always a favorite party food and are the first to go. Serve these chicken bites with a tasty mustard dipping sauce for extra flavor. These bites can be baked ahead and frozen, if desired, and then reheated.")]), _vm._v(" "), _c('p', {
    staticClass: "hang-space1"
  }, [_vm._v("1"), _c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("4")]), _vm._v(" pounds ground chicken")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("4")]), _vm._v(" cup mayonnaise")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("3 tablespoons fine dried bread crumbs")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 tablespoons minced fresh parsley")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 tablespoon finely chopped yellow onion")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("2")]), _vm._v(" teaspoon celery seed")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("2")]), _vm._v(" teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("4")]), _vm._v(" teaspoon dried oregano")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("4")]), _vm._v(" teaspoon dried basil")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Freshly ground pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Mustard Sauce (recipe follows) for dipping")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-space1"
  }, [_vm._v("Preheat the oven to 400°F. In a medium bowl, mix together all the ingredients except the Mustard Sauce, adding pepper to taste. Form into "), _c('sup', {
    staticClass: "frac"
  }, [_vm._v("3")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("4")]), _vm._v("- to 1-inch balls. Arrange the balls on a lightly sprayed or oiled baking sheet in a single layer and bake until lightly browned, 12 to 15 minutes. Transfer to a serving plate or chafing dish and serve hot with Mustard Sauce and toothpicks for spearing.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-space1"
  }, [_vm._v("Makes about 3 dozen")]), _vm._v(" "), _c('h4', [_c('strong', [_vm._v("MUSTARD SAUCE")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("2")]), _vm._v(" cup mayonnaise")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("4")]), _vm._v(" cup plain nonfat yogurt")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("3 tablespoons Dijon mustard")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 tablespoon white wine vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 teaspoon ground mustard")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 teaspoon Worcestershire sauce")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-space1"
  }, [_vm._v("In a small bowl, whisk together all the ingredients.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-space1"
  }, [_vm._v("Makes about 1 cup")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3dad97f9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/013-chapter5.vue
// module id = 93
// module chunks = 0